import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ez-sso-max-sessions',
  imports: [
    MatButtonModule,
    MatIconModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './sso-max-sessions.component.html',
  styleUrls: ['./sso-max-sessions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsoMaxSessionsComponent { }
